export default {
  messageBlocked: "Il messaggio è stato bloccato dal sistema",
  outboundCustomerLabel: "Inviato al cliente",
  customerActionCancel: "Annulla",
  customerActionReceipt: "Ricevuta",
  messageSent: "Messaggio inviato!",
  agreementReached: "✅ Prenotazione confermata!",
  sendMessageError: "Impossibile inviare il messaggio",
  cancelConfirm: "Vuoi davvero annullare questa conversazione?",
  conversationCancelled: "Conversazione annullata",
  cancelConversationError: "Impossibile annullare la conversazione",
  cancelReasonAdmin: "Annullato dallo staff",
  cancelReasonPartner: "Annullato dal venditore",
  reopenSession: "Riapri handshake",
  reopenSessionBusy: "Riapertura…",
  reopenSessionSuccess: "Handshake riaperto",
  reopenSessionError: "Impossibile riaprire l'handshake",
  reopenSessionConfirmTitle: "Riaprire l'handshake?",
  reopenSessionConfirmMessage:
    "La prenotazione torna in negoziazione così data e orario possono essere modificati in chat con il cliente.",
  reopenSessionConfirm: "Riapri handshake",
  loadingAudit: "Caricamento dati di audit...",
  replyPlaceholder: "Rispondi al cliente...",
  adminReplyPlaceholder: "Rispondi al cliente come partner...",
  conversationNotFound: "Conversazione non trovata",
  bookingDetails: {
    title: "Dettagli prenotazione",
    service: "Servizio prenotato",
    activity: "Attività",
    partyHeading: "Quantità",
    visitHeading: "Data e ora richieste",
    visitFull: "({{datetime}})",
    visitNotSet: "Data/ora non indicate — da concordare in chat",
    visitOpenShort: "Data da concordare in chat",
    visitScheduledMissingShort: "Data assente in prenotazione",
    quantityUnknown: "Non indicata",
    notes: "Note del cliente",
    partyGuests_one: "{{count}} ospite",
    partyGuests_other: "{{count}} ospiti",
    partyQuantity_one: "{{count}} unità",
    partyQuantity_other: "{{count}} unità",
  },
  started: "Avviata {{date}}",
  conversationEmpty: "Nessun messaggio. Rispondi per avviare la conversazione.",
  agreementReadOnly:
    "Handshake completata. La prenotazione risulta confermata su Flitrip.",
  confirmBooking: "Conferma prenotazione",
  confirmBookingHint:
    "Usalo quando in chat avete definito i dettagli con il cliente. Indica data e ora dell’esperienza, poi conferma su Flitrip.",
  confirmVisitDateLabel: "Data dell’esperienza",
  confirmVisitTimeLabel: "Ora",
  confirmVisitRequired: "Inserisci data e ora dell’esperienza.",
  confirmVisitMustBeFuture:
    "Data e ora dell’esperienza devono essere nel futuro. Scegli uno slot successivo se devi correggere la prenotazione.",
  confirmSlotRequired:
    "Seleziona una fascia oraria o inserisci un orario personalizzato.",
  confirmSlotsLabel: "Fasce orarie",
  confirmSlotsLoading: "Caricamento fasce…",
  confirmSlotsError: "Impossibile caricare le fasce per questo giorno.",
  confirmDayClosed: "Questo giorno risulta chiuso nel calendario.",
  confirmNoSlots: "Nessuna fascia oraria configurata per questo giorno.",
  confirmSlotSpotsRemaining: "{{count}} posto/i disponibili",
  confirmSlotInsufficient:
    "Restano {{remaining}} posto/i per {{partySize}} — puoi comunque confermare",
  confirmSlotFull: "Pieno — puoi comunque confermare",
  confirmSlotUnlimited: "Disponibile",
  confirmSlotRequested: "Richiesta",
  confirmCustomTimeLabel: "Orario personalizzato",
  confirmCustomTimeHint:
    "Usalo se avete concordato un orario non in elenco. Non consuma capienza della fascia.",
  confirmVisitPrefillHint:
    "Abbiamo precompilato la richiesta del cliente: modifica se in chat avete concordato un altro orario.",
  confirmBookingSuccess: "Prenotazione confermata su Flitrip.",
  confirmBookingError: "Impossibile confermare questo handshake.",
  acceptBooking: "Accetta",
  acceptBookingBusy: "Accettazione…",
  acceptBookingHint:
    "Conferma la prenotazione su Flitrip dopo aver concordato data e ora con il cliente in chat.",
  rejectBooking: "Rifiuta",
  rejectBookingBusy: "Rifiuto…",
  rejectBookingHint:
    "Rifiuta questa richiesta. Il cliente sarà avvisato e la prenotazione non proseguirà.",
  rejectSessionTitle: "Rifiutare questa prenotazione?",
  rejectSessionConfirm:
    "Il cliente sarà avvisato che la richiesta è stata rifiutata.",
  rejectSessionAction: "Rifiuta",
  confirmOverCapacityTitle: "Superare la capienza della fascia?",
  confirmOverCapacityMessage:
    "Questa fascia consente al massimo {{maxCapacity}} posti. {{bookedCount}} sono già confermati e ne restano {{availableSpots}}, ma questa prenotazione è per {{partySize}}. Puoi confermarla comunque se vuoi accettarla.",
  confirmOverCapacityConfirm: "Conferma comunque",
  conversationExpired: "Questa conversazione è scaduta",
  conversationCancelledStatus: "Questa conversazione è annullata",
  backToDashboard: "Torna alla dashboard",
  sessionIdShort: "ID sessione",
  cancelSession: "Annulla sessione",
  updated: "Aggiornata",
  closed: "Chiusa",
  references: "Riferimenti",
  bookingId: "ID prenotazione",
  sellerId: "ID venditore",
  auditTrail: "Traccia audit ({{count}} messaggi)",
  blockedCount: "Bloccati: {{count}}",
  noMessages: "Nessun messaggio in questa conversazione.",
  list: {
    quickStatusLabel: "Filtra per stato",
    quickStatusAll: "Tutte",
    adminTitle: "Dashboard handshake",
    adminDescription:
      "Verifica e monitora tutte le conversazioni cliente-venditore",
    conversationsFound_one: "{{count}} conversazione trovata",
    conversationsFound_other: "{{count}} conversazioni trovate",
    loadingConversations: "Caricamento conversazioni...",
    noConversationsFound: "Nessuna conversazione trovata",
    tryAdjustingFilters: "Prova a modificare i filtri",
    emptyHintAdmin: "Ancora nessuna conversazione di handshake",
    clearFilters: "Cancella filtri",
    loadFailedTitle: "Impossibile caricare le conversazioni",
    loadFailedHint: "Controlla la connessione e riprova.",
    loadFailedRetry: "Riprova",
    loadFailedStale:
      "Aggiornamento non riuscito. Mostriamo le conversazioni già caricate.",
  },
} as const;
